import { FC, ReactNode, useContext } from 'react'
import { Form, hooks, Hovercard } from 'roadie-ui'

type WrapperProps = {
  input: HTMLInputElement | null
  children: ReactNode
}

const OverlayWrapper: FC<WrapperProps> = (props) => {
  return <Hovercard dockBelow={props.input}>{props.children}</Hovercard>
}

const InlineWrapper: FC<WrapperProps> = (props) => {
  return <div>{props.children}</div>
}

const FormInputHint: FC<{ inline?: boolean; children: ReactNode }> = (props) => {
  const { input } = useContext(Form.InputContext)
  const hasFocus = hooks.useHasFocus(input)

  if (!hasFocus) {
    return null
  }

  const Wrapper = props.inline ? InlineWrapper : OverlayWrapper

  return <Wrapper input={input}>{props.children}</Wrapper>
}

export default FormInputHint
